export default __webpack_public_path__ + "static/media/logorotapreta.7625cb72.png";